<template>
    <div class="d-flex flex-wrap align-content-center justify-content-center h-100">
        <div v-for="(item, index) of localSelectedFields" :key="item.key">
            <b-button :variant="isFieldsTypeValidated ? 'light' : 'danger'"
                      class="mt-1 ml-1"
                      @click="removeAxisField(index)">
                {{ fieldLabel(item) }}
            </b-button>
        </div>
        <b-dropdown class="mt-1 ml-1"
                    boundary="window"
                    no-caret
                    variant="light"
                    @shown="cancelHideTag=true"
                    @hide="cancelHide">
            <template #button-content>
                <b-icon icon="plus"></b-icon>
            </template>
            <template v-for="item of fields">
                <b-dropdown-item-button :key="item.key"
                                        :active="isAxisFieldSelected(item)"
                                        :disabled="isFieldDisable(item)"
                                        @click="addField(item)">
                    {{ fieldLabel(item) }}
                </b-dropdown-item-button>
            </template>
        </b-dropdown>
        <b-form-select v-if="isXAxisTypeDate" class="date-split-selector" :options="dateSplitUnits"
                       v-model="localDateSplitUnit"></b-form-select>
    </div>
</template>

<script>
import TableChartMixins from "@/components/echarts-part/TableChart/mixins/TableChartMixins";

export default {
    name: "GroupFieldSelector",
    mixins: [TableChartMixins],
    props: {
        fields: Array,
        selectedFields: Array,
        dateSplitUnit: Number,
    },
    data() {
        return {
            localSelectedFields: [],
            cancelHideTag: false,
            localDateSplitUnit: -1,
        }
    },
    computed: {
        $_xAxisFields() {
            return this.localSelectedFields;
        },
        isFieldsTypeValidated() {
            return this.isXAxisTypeDate !== null;
        },
    },
    watch: {
        selectedFields: {
            handler() {
                if (this.selectedFields) {
                    this.localSelectedFields = this.selectedFields;
                }
            },
            immediate: true
        },
        dateSplitUnit: {
            handler() {
                if (this.dateSplitUnit !== undefined) {
                    this.localDateSplitUnit = this.dateSplitUnit;
                }
            },
            immediate: true
        },
        localDateSplitUnit() {
            this.$emit('update:dateSplitUnit', this.localDateSplitUnit);
        },
        localSelectedFields() {
            this.$emit('update:selectedFields', this.localSelectedFields);
            if (this.localSelectedFields.length > 0) {
                this.$emit('selected');
            }
        },
    },
    methods: {
        cancelHide(event) {
            if (this.cancelHideTag) {
                event.preventDefault();
                this.cancelHideTag = false;
            }
        },
        isAxisFieldSelected(item) {
            return this.isFieldSelected(this.localSelectedFields, item);
        },
        isFieldDisable(item) {
            if (this.isFieldsTypeValidated) {
                let selected = this.isAxisFieldSelected(item);
                if (this.isXAxisTypeDate === undefined || selected) return false;
                else if (this.isXAxisTypeDate) return true;
                else if (!this.isXAxisTypeDate) {
                    return this.isXAxisTypeDate !== this.isFieldTypeDate(item);
                }
            }
            return true;
        },
        removeAxisField(index) {
            this.removeField(this.localSelectedFields, index);
        },
        addField(item) {
            this.changeAxisFieldList(this.localSelectedFields, item);
        },
    }
}
</script>

<style scoped>

.date-split-selector {
    /*position: absolute;*/
    /*bottom: .3rem;*/
    left: 20%;
    right: 20%;
    width: 60%;
    margin-top: .3rem;
}
</style>
